import { defineConfig } from "./types";

console.log("Loading Kismet Config");

// Default configuration that applies to all environments
const defaultConfig = {
  monitoring: {
    unique_offer_id_param: "unique_lead_tracking_id",
  },
  chatbot: {
    open_modal_url_param: "kismet_modal_state",
  },
  socket: {
    port: 3002,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
  },
};

// Environment-specific configurations
const envConfigs = {
  development: {
    socket: {
      enable_sockets: false,
      url: "http://localhost:3002",
      port: 3002,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      allowed_origins: [
        "http://localhost:3001", // Chatbot
        "https://localhost:3001", // Chatbot HTTPS
        "http://localhost:3003", // Dashboard
      ],
    },
    backend: {
      base_url: "https://api.makekismet.com",
    },
    assets: {
      base_url: "/public",
    },
  },
  production: {
    socket: {
      // This will be replaced by the host site's domain
      enable_sockets: false,
      url: "https://api.kismet.yourdomain.com",
      port: 3002,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      allowed_origins: ["*"], // In production, configured by the hosting environment
    },
    backend: {
      base_url: "https://api.makekismet.com", //can put ngrok links here for testing
    },
    assets: {
      base_url: "https://cdn.kismet.yourdomain.com",
    },
  },
};

// Determine the current environment
const env = process.env.NODE_ENV || "production";

// Merge the configurations
export const config = defineConfig({
  ...defaultConfig,
  ...envConfigs[env as keyof typeof envConfigs],
  env: env as "development" | "production",
});
